<template>
  <div>
    <div id="section-to-print">
    
      <h1 style="text-align:center; margin-top: 10px; margin-bottom: 10px; font-family: Khmer Os Moul, 'Hanuman-Regular'">
        ប័ណ្ណទទួលទំនិញ
      </h1>

      <hr style="border-top: 3px solid green; margin-bottom: 5px;">

      <table style="margin-bottom: 20px;">
        <tr>
          <td>ឈ្មោះអតិថិជន</td>
          <td> : </td>
          <td><b> {{ datas.client_name }} </b></td>
          <td style="margin-left: 15px;"></td>
          <td>លេខទូរស័ព្ទអតិថិជន</td>
          <td> : </td>
          <td>{{ datas.client_phone | formatPhoneNumber}}</td>
        </tr>

        <tr>
          <td>ប្រភេទអតិថិជន</td>
          <td> : </td>
          <td colspan="4">រោងម៉ាស៊ីនកិនស្រូវ</td>
        </tr>

         <tr>
          <td>អាស័យដ្ឋានអតិថិជន</td>
          <td> : </td>
          <td colspan="4">{{ datas.client_full_location }}</td>
        </tr>

        <tr>
          <td>ឈ្មោះអ្នកផ្គត់ផ្គង់</td>
          <td> : </td>
          <td><b> {{ datas.supplier_name }} </b></td>
          <td style="margin-left: 15px;"></td>
          <td>លេខទូរស័ព្ទអ្នកផ្គត់ផ្គង់</td>
          <td> : </td>
          <td>{{ datas.supplier_mobile | formatPhoneNumber}}</td>
        </tr>

        <tr>
          <td>ប្រភេទអ្នកផ្គត់ផ្គង់</td>
          <td> : </td>
          <td colspan="4">ពាណិជ្ជករដំណាំ</td>
        </tr>

         <tr>
          <td>អាស័យដ្ឋានអ្នកផ្គត់ផ្គង់</td>
          <td> : </td>
          <td colspan="4">{{ datas.supplier_full_location }}</td>
        </tr>

        <tr>
          <td>អ្នកដឹកជញ្ជួន</td>
          <td> : </td>
          <td>{{ datas.driver_name }}</td>
          <td style="margin-left: 15px;"></td>
          <td>ទូរស័ព្ទអ្នកដឹកជញ្ជួន</td>
          <td> : </td>
          <td>{{ datas.driver_mobile | formatPhoneNumber }}</td>
        </tr>

        <tr>
          <td>ស្លាកលេខ</td>
          <td> : </td>
          <td>{{ datas.druck_plate_no }}</td>
          <td style="margin-left: 15px;"></td>
          <td>ទំងន់ទំនិញ</td>
          <td> : </td>
          <td>{{ +parseInt(datas.loading_weight) | formatNumber }} {{+datas.loading_weight ? ' KG' : '' }}</td>
          <td>{{ }}</td>
        </tr>

        <tr>
          <td>ទីតាំងលើក</td>
          <td> : </td>
          <td colspan="4">{{ datas.loading_area }}</td>
        </tr>

        <tr>
          <td>កាលបរិច្ឆេទ</td>
          <td> : </td>
          <td>{{ parseFromDate(datas.date) }}</td>
          <td style="margin-left: 15px;"></td>
          <td>កាលបរិច្ឆេទលើក</td>
          <td> : </td>
          <td>{{ parseFromDate(datas.loading_date) }}</td>
        </tr>

        <tr>
          <td>កាលបរិច្ឆេទទទួល</td>
          <td> : </td>
          <td>{{ parseFromDate(datas.accepted_date) }}</td>
          <td style="margin-left: 15px;"></td>
          <td>លេខទម្រង់បញ្ជាទិញ</td>
          <td> : </td>
          <td>{{ datas.reference }}</td>
        </tr>

      </table>

      <table class="border">
        <tr>
          <th>ល.រ</th>
          <th>ឈ្មោះទំនិញ</th>
          <th>ឯកតា</th>
          <th>បរិមាណ</th>
          <th>តម្លៃរាយ</th>
          <th>ថ្លៃសម្របសម្រួល</th>
          <th>តម្លៃសរុប</th>
        </tr>
        
        <tr v-for="(tra, index) in datas.transaction_line" :key="index">
          <td style="text-align: center">{{ index + 1 }}</td>
          <td>{{ tra.product_name }}</td>
          <td style="text-align: center">{{ tra.unit_name }}</td>
          <td style="text-align: center">{{ +tra.qty }}</td>
          <td style="text-align: right">{{ +tra.price | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</td>
          <td style="text-align: right">{{ +tra.fee | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</td>
          <td style="text-align: right">{{ +tra.price * +tra.qty | formatNumber}}{{ getCurrencySymbol(datas.currency_code) }}</td>
        </tr>

        <tr>
          <th colspan="6" style="text-align: right">ដកថ្លៃផ្សេៗ</th>
          <th style="text-align: right;">{{ datas.total_discount | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</th>
        </tr>

        <tr>
          <th colspan="6" style="text-align: right">សរុប</th>
          <th style="text-align: right;">{{ +datas.total_amount - +datas.total_discount | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</th>
        </tr>
      </table>
      
      <table style="margin-top: 15px;">
        <tr>
          <td>ពិនិត្យដោយ</td>
          <td style="text-align: center">{{ isCropTrader ? 'អ្នកបញ្ជាទិញ' : 'អ្នកបញ្ជាលក់'}}</td>
        </tr>
        <tr>
          <td style="padding-top: 50px;">កាលបរិច្ឆេទ: ...............................</td>
        </tr>
      </table>

      <!-- <div class="footer-right">
        <p>Instant DN Form-V0 {{ today }}</p>
      </div> -->
    </div>


  </div>

</template>

<script>

import {provider} from "@/service/provider";
import axios from "axios";
import MainMixin from "../../../mixins/mainMixin"
import moment from "moment";

export default {
  mixins: [MainMixin],
  data() {
    return {
      transaction_id: '',
      today         :moment().format("YYYYMMDD"),
      datas: {},
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },

    handleRun() {
      if(this.transaction_id){
        let vm      = this;
        let url     = provider.baseURL + provider.fetchListBuyBackInvoice;
        let params  = {
            reference: "",
            search: "",
            id: this.transaction_id,
            offset: 0,
            sort_by: "",
            sort_desc: 0,
            limit: 1,
            from_date: this.from_date,
            to_date: this.to_date
        };

        axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response && res.data.response.code === 200) {

            let data = res.data.data[0];
            vm.datas = data;
            vm.$nextTick(() => { window.print(); });
            vm.$nextTick(() => { this.$router.back(); });
          }
        }).catch(error => console.log(error));

      }else{
        this.$router.back();
      }
    }
  },
  mounted(){ this.handleRun() },
  created() { this.transaction_id = this.$route.params.id; }
}
</script>